<div class="step-block" [ngClass]="data?.style" *ngIf="data?.steps">
    <div class="container">
        <div class="title">{{data?.title}}</div>
        <div class="text" [innerHTML]="data?.text | safeHtml"></div>
        <div class="steps">
            <div class="step" *ngFor="let step of data?.steps">
                <div class="step-listing">{{step.step}}</div>
                <div class="step-title">{{step.title}}</div>
                <div class="step-text">
                    <finder-generic-text [data]="{text: step.text}"></finder-generic-text>
                </div>
            </div>
        </div>
    </div>
</div>
